/* Inside Skin Clinic: gentle scroll reveal + videos that play only while on screen. */
(function () {
  if (window.__iscInit) return;
  window.__iscInit = true;
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!designMode && !reduce) document.documentElement.classList.add('isc-js');

  var revealIO = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); revealIO.unobserve(e.target); } });
  }, { rootMargin: '0px 0px -8% 0px' }) : null;

  var videoIO = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      var v = e.target;
      if (e.isIntersecting && !v.dataset.userPaused) { v.muted = true; var p = v.play(); if (p && p.catch) p.catch(function () {}); }
      else if (!e.isIntersecting) { v.pause(); }
    });
  }, { threshold: 0.35 }) : null;

  function init(root) {
    root = root || document;
    root.querySelectorAll('.isc-reveal:not(.is-in)').forEach(function (el) {
      if (revealIO && !designMode) revealIO.observe(el); else el.classList.add('is-in');
    });
    if (!reduce && videoIO) root.querySelectorAll('video[data-isc-autoplay]').forEach(function (v) { videoIO.observe(v); });
    root.querySelectorAll('[data-isc-vtoggle]').forEach(function (btn) {
      if (btn.dataset.bound) return; btn.dataset.bound = '1';
      var v = btn.parentNode.querySelector('video'); if (!v) return;
      if (reduce) btn.setAttribute('aria-pressed', 'true');
      btn.addEventListener('click', function () {
        if (v.paused) { delete v.dataset.userPaused; v.play(); btn.setAttribute('aria-pressed', 'false'); btn.setAttribute('aria-label', 'Pause video'); }
        else { v.dataset.userPaused = '1'; v.pause(); btn.setAttribute('aria-pressed', 'true'); btn.setAttribute('aria-label', 'Play video'); }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); }); else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
